// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion {
  direction: ltr;
}

.container-accordion a {
  color: black;
  font-family: "Lato", sans-serif !important;
  font-size: 15px;
}
.container-accordion ul {
  width: 100%;
  margin-bottom: 0;
  padding: 0;
}
.container-accordion .accordion-body {
  padding: 0;
}
.container-accordion .accordion-button:focus {
  border: none !important;
  box-shadow: none !important;
}
.container-accordion .accordion-item {
  border: none;
}
.container-accordion .firstClass {
  margin-left: 0rem !important;
}
.container-accordion .accordion-item-title {
  font-size: 15px;
  color: gray;
  padding: 0;
  margin: 0;
  padding-left: 1em;
  text-align: left;
  margin-left: 0.5rem;
}
.container-accordion .accordion-divider {
  border-bottom: 1px solid rgb(233, 233, 233) !important;
}
.container-accordion .dropdown-item {
  display: inline-block;
  padding: 0.25rem 1rem !important;
  display: flex;
  align-items: center;
  gap: 0.2em;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-align: start;
  margin-left: 1rem;
}
.container-accordion .dropdown-item .spinner-grow {
  border-color: rgb(143, 0, 60);
  background-color: rgb(143, 0, 60);
  width: 1em;
  height: 1em;
}
.container-accordion .dropdown-item:hover {
  color: #8f003c;
}
.container-accordion .first-level-link {
  gap: 1em;
  font-size: 1rem;
  padding: 1.25em !important;
  margin-left: 0rem;
}
.container-accordion .feedback {
  color: rgb(143, 0, 60);
}
@media (max-width: 1200px) {
  .container-accordion .dropdown-item {
    justify-content: flex-start !important;
  }
  .container-accordion .accordion-item-title {
    font-size: 1.25em !important;
  }
  .container-accordion .first-level-link {
    padding: 0 !important;
    padding-left: 1.25rem !important;
  }
  .container-accordion .accordion-divider {
    height: 5em !important;
  }
  .container-accordion .accordion > div:has(> li) {
    max-height: 52px !important;
  }
  .container-accordion .accordion-body li {
    max-height: 5em;
  }
}

@media (min-width: 576px) {
  .container-accordion {
    overflow-y: scroll;
    height: 80vh;
  }
}
.dropdown-loading {
  width: 100%;
  height: 50em;
  display: flex;
  justify-content: center;
  align-items: center;
}

`, "",{"version":3,"sources":["webpack://./src/sass/layout/accordion/accordion.scss","webpack://./src/sass/layout/accordion/accordion.css","webpack://./src/sass/utilities/_variables.scss"],"names":[],"mappings":"AAGA;EACE,cAAA;ACFF;;ADME;EACE,YAAA;EACA,0CERG;EFSH,eAAA;ACHJ;ADKE;EACE,WAAA;EACA,gBAAA;EACA,UAAA;ACHJ;ADKE;EACE,UAAA;ACHJ;ADKE;EACE,uBAAA;EACA,2BAAA;ACHJ;ADKE;EACE,YAAA;ACHJ;ADQE;EACE,4BAAA;ACNJ;ADQE;EACE,eAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;ACNJ;ADQE;EACE,sDAAA;ACNJ;ADQE;EACE,qBAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;ACNJ;ADOI;EACE,6BAAA;EACA,iCAAA;EACA,UAAA;EACA,WAAA;ACLN;ADSE;EACE,cAAA;ACPJ;ADUE;EACE,QAAA;EACA,eAAA;EACA,0BAAA;EACA,iBAAA;ACRJ;ADWE;EACE,sBAAA;ACTJ;ADYE;EACE;IACE,sCAAA;ECVJ;EDaE;IACE,4BAAA;ECXJ;EDcE;IACE,qBAAA;IACA,gCAAA;ECZJ;EDeE;IACE,sBAAA;ECbJ;EDgBE;IACE,2BAAA;ECdJ;EDkBI;IACE,eAAA;EChBN;AACF;;ADoBA;EACE;IACE,kBAAA;IACA,YAAA;ECjBF;AACF;ADoBA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AClBF","sourcesContent":["@import \"../../utilities/mixins\";\n@import \"../../utilities/variables\";\n\n.accordion {\n  direction: ltr;\n}\n\n.container-accordion {\n  a {\n    color: black;\n    font-family: $Font;\n    font-size: 15px;\n  }\n  ul {\n    width: 100%;\n    margin-bottom: 0;\n    padding: 0;\n  }\n  .accordion-body {\n    padding: 0;\n  }\n  .accordion-button:focus {\n    border: none !important;\n    box-shadow: none !important;\n  }\n  .accordion-item {\n    border: none;\n  }\n  .accordion-header {\n    // height: 2.4rem;\n  }\n  .firstClass {\n    margin-left: 0rem !important;\n  }\n  .accordion-item-title {\n    font-size: 15px;\n    color: gray;\n    padding: 0;\n    margin: 0;\n    padding-left: 1em;\n    text-align: left;\n    margin-left: 0.5rem;\n  }\n  .accordion-divider {\n    border-bottom: 1px solid rgb(233, 233, 233) !important;\n  }\n  .dropdown-item {\n    display: inline-block;\n    padding: 0.25rem 1rem !important;\n    display: flex;\n    align-items: center;\n    gap: .2em;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    text-align: start;\n    margin-left: 1rem;\n    .spinner-grow {\n      border-color: rgb(143, 0, 60, 1);\n      background-color: rgb(143, 0, 60, 1);\n      width: 1em;\n      height: 1em;\n    }\n  }\n\n  .dropdown-item:hover {\n    color: #8f003c;\n  }\n\n  .first-level-link {\n    gap: 1em;\n    font-size: 1rem;\n    padding: 1.25em !important;\n    margin-left: -0rem;\n  }\n\n  .feedback {\n    color: rgb(143, 0, 60, 1);\n  }\n\n  @media (max-width: 1200px) {\n    .dropdown-item {\n      justify-content: flex-start !important;\n    }\n\n    .accordion-item-title {\n      font-size: 1.25em !important;\n    }\n\n    .first-level-link {\n      padding: 0 !important;\n      padding-left: 1.25rem !important;\n    }\n\n    .accordion-divider {\n      height: 5em !important;\n    }\n\n    .accordion > div:has(> li) {\n      max-height: 52px !important;\n    }\n\n    .accordion-body {\n      li {\n        max-height: 5em;\n      }\n    }\n  }\n}\n@media (min-width: 576px) {\n  .container-accordion {\n    overflow-y: scroll;\n    height: 80vh;\n  }\n}\n\n.dropdown-loading{\n  width: 100%;\n  height: 50em;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}",".accordion {\n  direction: ltr;\n}\n\n.container-accordion a {\n  color: black;\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 15px;\n}\n.container-accordion ul {\n  width: 100%;\n  margin-bottom: 0;\n  padding: 0;\n}\n.container-accordion .accordion-body {\n  padding: 0;\n}\n.container-accordion .accordion-button:focus {\n  border: none !important;\n  box-shadow: none !important;\n}\n.container-accordion .accordion-item {\n  border: none;\n}\n.container-accordion .firstClass {\n  margin-left: 0rem !important;\n}\n.container-accordion .accordion-item-title {\n  font-size: 15px;\n  color: gray;\n  padding: 0;\n  margin: 0;\n  padding-left: 1em;\n  text-align: left;\n  margin-left: 0.5rem;\n}\n.container-accordion .accordion-divider {\n  border-bottom: 1px solid rgb(233, 233, 233) !important;\n}\n.container-accordion .dropdown-item {\n  display: inline-block;\n  padding: 0.25rem 1rem !important;\n  display: flex;\n  align-items: center;\n  gap: 0.2em;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  text-align: start;\n  margin-left: 1rem;\n}\n.container-accordion .dropdown-item .spinner-grow {\n  border-color: rgb(143, 0, 60);\n  background-color: rgb(143, 0, 60);\n  width: 1em;\n  height: 1em;\n}\n.container-accordion .dropdown-item:hover {\n  color: #8f003c;\n}\n.container-accordion .first-level-link {\n  gap: 1em;\n  font-size: 1rem;\n  padding: 1.25em !important;\n  margin-left: 0rem;\n}\n.container-accordion .feedback {\n  color: rgb(143, 0, 60);\n}\n@media (max-width: 1200px) {\n  .container-accordion .dropdown-item {\n    justify-content: flex-start !important;\n  }\n  .container-accordion .accordion-item-title {\n    font-size: 1.25em !important;\n  }\n  .container-accordion .first-level-link {\n    padding: 0 !important;\n    padding-left: 1.25rem !important;\n  }\n  .container-accordion .accordion-divider {\n    height: 5em !important;\n  }\n  .container-accordion .accordion > div:has(> li) {\n    max-height: 52px !important;\n  }\n  .container-accordion .accordion-body li {\n    max-height: 5em;\n  }\n}\n\n@media (min-width: 576px) {\n  .container-accordion {\n    overflow-y: scroll;\n    height: 80vh;\n  }\n}\n.dropdown-loading {\n  width: 100%;\n  height: 50em;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n","// Utils\n$DecorationNone: none;\n$Font: \"Lato\", sans-serif !important;\n$Font-size-navbar: 12px;\n$LetterSpacing: 0px;\n\n// Colors\n$Transparent: rgba(0, 0, 0, 0);\n$RedColor: rgb(143, 0, 60, 1);\n$White: rgba(255, 255, 255, 1);\n$Black: rgba(26, 25, 25, 1);\n$MainBackgroundColor: rgba(247, 248, 249, 1);\n$SecondaryBackgroundColor: rgba(221, 208, 208, 0.5);\n$GrayColor: rgba(204, 204, 204, 1);\n$LinkColor: rgba(18, 101, 183, 1);\n$LinkSecondColor: rgba(78, 125, 162, 1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
